import get from 'lodash/get';
import { requestGet } from '../../../services/real.backend';
import { API_GET_MANAGER_LINKS } from '../../../services/apiPoints';

export default function getManagerLinks(userID) {
  return new Promise((resolve, reject) => requestGet(API_GET_MANAGER_LINKS.replace('{id}', userID))
    .then((resp) => {
      const links = get(resp, 'links', []);
      resolve(links);
    })
    .catch((e) => reject(e)));
}
